import React from 'react'

import { Body3, Box, Heading4 } from '@gousto-internal/citrus-react'

export const SignupMotivationsDescription = () => (
  <Box paddingH={[3, 3, 2]} style={{ paddingTop: '15px' }} paddingBottom={[3, 3, 0]}>
    <Heading4 data-testid="signup-description-header">Based on what matters to you</Heading4>
    <Body3 data-testid="signup-description-body">
      Here’s our top picks to help you hit your goals.
    </Body3>
  </Box>
)
